<template>
  <form class="action-buttons" @submit.prevent="handleSubmit">
    <button
        type="button"
        class="cancel-button text-center"
        @click="handleCancel"
        tabindex="0"
        aria-label="Cancel action">
      Cancel
    </button>
    <button
        type="submit"
        class="continue-button text-center"
        tabindex="0"
        aria-label="Continue to next step">
      Doorgaan
    </button>
  </form>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ActionButtons',
  emits:['cancel','continue'],
  methods: {
    handleCancel(): void {
      this.$emit('cancel');
    },
    handleSubmit(): void {
      this.$emit('continue');
    }
  }
});
</script>

<style scoped>
.action-buttons {
  display: flex;
  margin-top: 24px;
  min-height: 40px;
  width: 100%;
  align-items: center;
  gap: 24px;
  white-space: nowrap;
  justify-content: start;
  flex-wrap: wrap;
  font: 700 14px/24px Montserrat, sans-serif;
}

.cancel-button {
  border-radius: 8px;
  min-width: 240px;
  min-height: 40px;
  gap: 8px;
  color: var(--Neutral-5, #191a1f);
  flex: 1;
  margin: auto 0;
  padding: 8px 12px;
  cursor: pointer;
  border: none;
  background: transparent;
}

.continue-button {
  border-radius: 8px;
  background: var(--Primary-Primary, #080aed);
  min-width: 240px;
  min-height: 40px;
  gap: 8px;
  color: var(--Neutral-1, #fcfcfc);
  flex: 1;
  margin: auto 0;
  padding: 8px 12px;
  cursor: pointer;
  border: none;
}

.continue-button:focus,
.cancel-button:focus {
  outline: 2px solid var(--Primary-Primary, #080aed);
  outline-offset: 2px;
}

@media (max-width: 991px) {
  .action-buttons {
    max-width: 100%;
    white-space: initial;
  }

  .cancel-button,
  .continue-button {
    white-space: initial;
  }
}
</style>